<span
  tooltipPosition="top"
  tooltipZIndex="2100"
  [escape]="false"
  [hideDelay]="250"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss">
  @if (isLabelDisplay && label !== undefined && label !== null && label.trim().length > 0) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label">
      {{ label }}
    </label>
  }
  <div
    [ngClass]="[
      'input-json-body',
      (!chips || !chips.length) && isMandatory ? 'mandatory' : '',
      isReadOnly ? 'disabled' : '',
    ]">
    <div [ngClass]="['json-chip-list']">
      @for (chip of chips; track i; let i = $index) {
        <div class="json-chip">
          <span class="json-chip-label" (click)="showCreationPanel($event, chip)">
            @if (fieldDisplayeds?.length === 1) {
              <p>{{ chip[fieldDisplayeds[0].name] }}</p>
            } @else {
              @for (fieldDisplayed of fieldDisplayeds; track $index) {
                <p class="multiLabel">{{ fieldDisplayed.nameToShow }} = {{ chip[fieldDisplayed.name] }}</p>
              }
            }
          </span>
          <span class="remove-json-chip" (click)="removeJsonChip($event, i)">x</span>
        </div>
      }
      <div
        class="json-input"
        [ngStyle]="!this.uniqueProp || (!hasMultiValues && chips.length === 1) ? { display: 'none' } : {}">
        <input
          #inputtext
          autocomplete="off"
          data-cy="input-json"
          type="text"
          [attr.data-cy-columnName]="columnName"
          [attr.placeholder]="chips && chips.length ? null : placeholder"
          [disabled]="isReadOnly"
          [ngClass]="[
            'chip-input',
            chips?.length > 0 && inputtext.value.trim() === '' ? 'chip-input-small' : '',
            isNotAuthorized ? 'redText' : '',
          ]"
          [ngStyle]="this.focused && inputtext.value.trim() !== '' ? { width: '100%' } : {}"
          [ngStyle]="inputStyle"
          [readonly]="isReadOnly"
          [tabindex]="isReadOnly ? '-1' : null"
          (blur)="onInputBlur($event)"
          (focus)="!isReadOnly ? onInputFocus($event) : null"
          (keydown)="onKeydown($event)" />
      </div>
    </div>
    @if (!this.uniqueProp && !isReadOnly && (hasMultiValues || chips.length === 0)) {
      <button
        class="button p-button-secondary add-json-chip"
        icon="icon-add"
        pButton
        type="button"
        (click)="showCreationPanel($event)"></button>
    }
  </div>
  @if (hasConflict && dataStored) {
    <i
      #spanInput
      aria-hidden="true"
      class="rtconflict fas fa-exclamation-triangle iconClass"
      (click)="showConflictPanel($event)"></i>
  }

  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="false">
      <iu-value-preference-panel
        [data]="this.data"
        [dataStored]="this.dataStored"
        [fieldValue]="fieldValue"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</span>

<iu-prime-overlay #opCreation appendTo="body">
  <div class="vcrJsonCreationContainer">
    <div #jsonFieldsContainer class="jsonFields">
      <ng-template #vcrCreation />
    </div>

    @if (isFree) {
      <div class="inputjson-split-button">
        <div class="inputjson-split-button-toggle-button" [ngClass]="{ 'split-button-open': isSplitButtonOpen }">
          <button
            class="button p-button-secondary add-panel-line"
            icon="icon-add"
            pButton
            type="button"
            [label]="'inputJson.addString' | translate"
            (click)="addLineToPanel($event)"></button>
          <button
            class="button p-button-secondary add-panel-line"
            pButton
            type="button"
            [icon]="isSplitButtonOpen ? 'icon-open' : 'icon-next'"
            (click)="isSplitButtonOpen = !isSplitButtonOpen"></button>
        </div>
        @if (isSplitButtonOpen) {
          <div class="inputjson-split-button-list">
            <button
              class="p-col-12 p-button p-button-info"
              icon="icon-add"
              pButton
              [label]="'inputJson.addObject' | translate"
              (click)="addLineToPanel($event, true)"></button>
          </div>
        }
      </div>
    }
  </div>
</iu-prime-overlay>

<iu-prime-overlay #opConflict>
  <a class="data-conflict" (click)="chooseData($event, (dataStored?.data)[data.columnName], true); opConflict.hide()">{{
    (dataStored?.data)[data.columnName]
  }}</a>
  |
  <a class="data-conflict" (click)="chooseData($event, conflictedData, false); opConflict.hide()">{{
    conflictedData
  }}</a>
</iu-prime-overlay>
